// The published verifier relies on the global `Buffer`. The site is bundled by
// plain esbuild with no `inject` support, so this module installs the polyfill
// on globalThis instead. It must be the FIRST import in main.ts: ESM evaluation
// order guarantees it runs before the verifier module's top-level Buffer.from
// calls.
import { Buffer } from "buffer";

(globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer;
